import { ModelProps } from "./model";
import { Funcionario } from "./modulos/funcionario/funcionario.model";

export interface UserAuth {
    _id: any
    _rev: any
    _attachments: any
    name: string
    pass?: string
    roles: any[]
    metadados: {
        empresa: Empresa
        db_name: string
        db_start: boolean
        db_access: boolean//acesso consedido ao usuario para acessar o banco
        active: boolean
    }
}

export interface Empresa {
    razao: string;
    fantasia: string;
    numero_doc: string;
    tipo_doc: string;
    pais: string;
    uf: string;
    cidade: string;
    cep: string;
    bairro: string;
    logradouro: string;
    numero: string;
    complemento: string;
    logo: string;
    whatsapp: string;
    site: string;
}

export interface Config extends ModelProps {
    _id: "@CONFIG"
    _rev: any,
    seq_cod_item: number
    seq_cod_mov: number
    qt_dig_cod_item: number
    qt_dig_cod_mov: number
    meio_pag_default: MeioPag
    cliente_default: Pessoa
    data_ini_estoque: string
    tabela_preco_default: TabelaPrecoConfig
}

export interface MainMenu {
    text: string,
    icon: any,
    eventOnClick: () => any
}

export enum TipoPessoa {
    cliente = "cliente",
    fornecedor = "fornecedor",
    usuario = "usuario",
    funcionario = "funcionario"
}


export interface Pessoa extends ModelProps {
    type: TipoPessoa,
    nome: string;
    sobrenome: string;
    apelido: string;
    whatsapp: string;
    fone: string,
    email: string;
    senha: string;//senha de acesso ao app
    enderecos: Endereco[];
    idx_endereco_main: number//index do endereco principal 
    tipo_doc: "CPF" | "CNPJ";//J juridica F fisica
    n_doc: string;//cpf cnpj   
    ativo: boolean;
}

export interface Endereco {
    _id: string | undefined;
    rua: string;
    numero: string;
    bairro: string;
    complemento?: string;
    cidade: string;
    uf: string;
    cep: string
    referencia?: string;
    latitude: number;
    longitude: number;
    contato?: {
        nome: string;
        whatsapp: string;
    }
}

export const initialValueEndereco: Endereco = {
    _id: undefined,
    bairro: "",
    cep: "",
    cidade: "",
    latitude: 0,
    longitude: 0,
    numero: "",
    rua: "",
    uf: "",
    complemento: "",
    contato: {
        nome: "",
        whatsapp: ""
    }
}

export interface MeioPag extends ModelProps {
    type: "meiopag"
    descricao: string
    perc_desc: number//percentual de desconto
    show_movel: boolean,
    gerar_titulo: boolean,
    obs: string,
    local_pag: "presencial" | "online",
    ativo: boolean
}

export interface TabelaPrecoConfig extends ModelProps {
    type: "tabelapreco"
    descricao: string
    ativo: boolean
}

export interface Convenio extends ModelProps {
    type: "convenio"
    descricao: string
    ativo: boolean
}

export interface TabelaPrecoItem extends TabelaPrecoConfig {
    valor: number
}

export interface ValorMpCondicional {
    _id: any,
    valor: number,
    mp_condicional: Array<{ _id: any, descricao: string }>
}

export interface ConvenioItem {
    convenios: Array<{ _id: string, descricao: string, }>,
    valor_mp_cond: Array<ValorMpCondicional>
}

export interface Item extends ModelProps {
    _attachments: any;
    type: "item";
    codigo: string;
    descricao: string;
    detalhes: string;
    custo: number;
    comissao: number;
    ativo: boolean
    qt_max_estoque: number;//quantidade maxima de armazenamento em estoque, para facilitar a recomendacao de compra
    saldo?: number
    info_dt_validade: boolean
    tabela_preco: TabelaPrecoItem[]
    convenio_preco?: ConvenioItem
}

export enum TipoMovDesc {
    PEDIDO = "PEDIDO",
    VENDA = "VENDA",
    COMPRA = "COMPRA",
    AVARIA = "AVARIA",
    BALANCO = "BALANCO",
}

export interface TipoMovimentacao extends ModelProps {
    type: "tipomov";
    descricao: TipoMovDesc | "";
    mov_estoque: boolean;//informa se o tipo movimenta estoque
    detalhes: string;
    direcao_estoque: "E" | "S" | "";//se é entrada, saida de estoque ou neutro
    gera_mov_fin: boolean;//se gera movimentacao financeira
    alterar_item: boolean;//se altera o cadastro do item
}

export interface CanalDistMov {
    _id: string,
    data: string,
    funcionario: {
        _id: string,
        nome: string,
        whatsapp: string,
    }
}

export interface Movimentacao extends ModelProps {
    type: "mov"//tipo doc
    tipo_mov: TipoMovimentacao
    codigo: string
    pessoa: {
        _id: string
        nome: string
        whatsapp: any
        enderecos: Endereco[]
        revenda?: boolean
        tabela_preco_padrao?: TabelaPrecoConfig
        meio_pag_default?: MeioPag;
    }
    local: 'loja' | 'app' | 'bot'
    situacao: "INICIADO" | "ABERTO" | "ENTREGA" | "FINALIZADO" | "SOLICITADO"//solicitado é quando um outro entregador pede para entregar um pedido que ja esta marcado para entrega, ou seja a mov já tem um canal de distribuiçao 
    data_situacao: string
    fechamento: FechamentoMov
    entrega?: Endereco;
    canal_dist: CanalDistMov
    canal_dist_soliciado?: {
        //Outro canal de distribuicao que solicitou a entrega depois de um canal ja ter pego para entrega
        //O canal de distriuicao inicial pode aceitar ou recusar a solicitacao
        //caso aceite o canal de distribuicao é substituido pelo canal solicitado, e o canal solicitado é removido
        //caso nao aceite o canal é marcado como negado
        //a solicitacao so deve ser disponibilizada se a situacao da mov for ENTREGA
        _id: string,
        funcionario: {
            _id: string,
            nome: string,
        }
    }
    obs: string,
    itens: ItemMov[]
}


export interface MeioPagMov extends MeioPag {
    valor: number
    sit_pag: "aberto" | "pago"
    _id_conta?: any
    anexo?: any
}

export interface FechamentoMov {
    subtotal: number;
    descontos: number;
    acrescimos: number;
    total: number;
    pagamentos: MeioPagMov[];
}

export interface ItemMov {
    _id: any,
    item: { _id: string, codigo: string, descricao: string, tabela_preco: TabelaPrecoItem, info_dt_validade?: boolean },
    qt: number,
    valor: number,
    total: number,
    ano_validade?: number
}

export interface CanalDistribuicao extends ModelProps {
    type: "canaldist",
    funcionario: Funcionario,
    situacao: "PENDENTE" | "ABERTO" | "FECHADO",//pendente é quando o estoque_dist ainda nao foi adicionado
    data: string
    estoque_dist: EstoqueCanalDistriuicao[]
    despesas: DespesaCanalDistribuicao[]
    fechamento: {
        resumo_mp: ResumoMPCanalDistribuicao[]
        total: number
    }
}

export interface EstoqueCanalDistriuicao {
    _id: any,
    item: Item,
    qt: number
}

export interface DespesaCanalDistribuicao {
    _id: any,
    descricao: string,
    valor: number
}

export interface ResumoMPCanalDistribuicao {
    desc_pagamento: string,
    total: number
}

export interface Contas extends ModelProps {
    type: "contas",
    tipo: "receber" | "pagar",
    pessoa: {
        _id: string,
        nome: string
    },
    movimentacao: {
        _id: string,
        codigo: string
    },
    descricao: string,
    valor: number,
    data_venc: string,
    situacao: "parcial" | "pago" | "aberto",
    recebimentos: RecebimentoConta[]
}

export interface RecebimentoConta {
    _id: any,
    data: string,
    canal_dist: {
        _id: string,
        funcionario: {
            _id: string,
            nome: string
        }
    },
    meio_pag: MeioPag,
    valor: number
}

export interface ResumoContasPessoa {
    key: {
        _id: string,
        nome: string
    },
    value: number
}

export interface Estoque extends ModelProps {
    type: "estoque",
    data: string,
    itens: EstoqueItem[]
}

export interface EstoqueItem {
    _id: any,
    item: {
        _id: string,
        descricao: string
    },
    qt: number
}

export interface EstoqueItemView {
    _id: any,
    descricao: string,
    qt: number
}

export interface Galeria extends ModelProps {
    _id: "@GALERIA",
    type: "galeria",
    _attachments: {
        [key: string]:File
    }
}

export interface File {
    content_type: string,
    data: string,
    tipo: "doc" | "img" | "video",
    descricao: string
}